import React from 'react';

import ArtifactForm, {
  ArtifactFormComponentProps,
} from '@/features/artifacts/components/ArtifactForm';

import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';
import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';

const EncaminhamentoFormDefault: ArtifactFormOverrides = [
  { name: 'reasonCode', label: 'Indicação clínica' },
];

export type FormEncaminhamentoProps = ArtifactFormComponentProps;

const FormEncaminhamento: React.FC<FormEncaminhamentoProps> = ({
  resource,
  onSubmit,
  onCancel,
  disabled = false,
  loading = false,
}) => {
  const form = useArtifactFormConfig(
    'encaminhamento',
    EncaminhamentoFormDefault,
  );

  return (
    <ArtifactForm
      form={form}
      resource={resource}
      loading={loading}
      disabled={disabled}
      onResourceSubmit={onSubmit}
      onResourceSubmitCancel={onCancel}
    />
  );
};

export default FormEncaminhamento;
